import type { Route } from './+types/course'
import { CourseDetail } from '@/pages/CourseDetail'
import { courseClassOutlines } from '@/lib/courseClasses.server'
import { buildCourseMeta } from '@/lib/pageMeta'

export function meta({ params }: Route.MetaArgs) {
  return buildCourseMeta(params.slug)
}

export async function loader({ params }: Route.LoaderArgs) {
  return { classes: await courseClassOutlines(params.slug) }
}

export default function CourseRoute({ loaderData }: Route.ComponentProps) {
  return <CourseDetail classes={loaderData.classes} />
}
